module.exports = __webpack_public_path__ + "static/media/site-robertarachid-ecommerce-768x591.3958408f.jpg";